var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index,staticClass:"content",on:{"click":function($event){return _vm.details(item)}}},[_c('div',[_c('div',{staticClass:"left-tit"},[_vm._v(_vm._s(item.title))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }